export default "__VITE_ASSET__DAXRifTl__"